import * as React from 'react';
import { UIText1, IconMetroMsk16 } from '@cian/ui-kit';

import * as styles from './underground.css';

export const Underground = ({ name, color }: { name: string; color: string }) => {
  return (
    <div className={styles['underground']}>
      <div className={styles['icon']} style={{ color }}>
        <IconMetroMsk16 color="current_color" />
      </div>
      <UIText1 color="black_100">{name}</UIText1>
    </div>
  );
};
